module.exports = require("@pb/kit-util-should-update");